var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v(_vm._s(_vm.label)+" "+_vm._s(_vm.type)+" block "),_c('strong',[_vm._v(_vm._s(_vm.details.name))]),_vm._v(" ("),_c('a',{attrs:{"href":_vm.link}},[_vm._v("Link")]),_vm._v(")")])])}
var staticRenderFns = []

export { render, staticRenderFns }